var _mask, _path, _mask2, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_33_6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214 442.123C209.582 442.123 206 445.705 206 450.123V514.452C206 518.87 202.418 522.452 198 522.452H133C128.582 522.452 125 518.87 125 514.452V449.452C125 445.034 128.582 441.452 133 441.452H197C201.418 441.452 205 437.87 205 433.452V368.123C205 363.705 208.582 360.123 213 360.123H279C283.418 360.123 287 363.705 287 368.123V434.123C287 438.541 283.418 442.123 279 442.123H214Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206 450.123H204V514.452H206H208V450.123H206ZM198 522.452V520.452H133V522.452V524.452H198V522.452ZM125 514.452H127V449.452H125H123V514.452H125ZM133 441.452V443.452H197V441.452V439.452H133V441.452ZM205 433.452H207V368.123H205H203V433.452H205ZM213 360.123V362.123H279V360.123V358.123H213V360.123ZM287 368.123H285V434.123H287H289V368.123H287ZM279 442.123V440.123H214V442.123V444.123H279V442.123ZM287 434.123H285C285 437.437 282.314 440.123 279 440.123V442.123V444.123C284.523 444.123 289 439.646 289 434.123H287ZM279 360.123V362.123C282.314 362.123 285 364.809 285 368.123H287H289C289 362.6 284.523 358.123 279 358.123V360.123ZM205 368.123H207C207 364.809 209.686 362.123 213 362.123V360.123V358.123C207.477 358.123 203 362.6 203 368.123H205ZM197 441.452V443.452C202.523 443.452 207 438.975 207 433.452H205H203C203 436.766 200.314 439.452 197 439.452V441.452ZM125 449.452H127C127 446.138 129.686 443.452 133 443.452V441.452V439.452C127.477 439.452 123 443.929 123 449.452H125ZM133 522.452V520.452C129.686 520.452 127 517.766 127 514.452H125H123C123 519.975 127.477 524.452 133 524.452V522.452ZM206 514.452H204C204 517.766 201.314 520.452 198 520.452V522.452V524.452C203.523 524.452 208 519.975 208 514.452H206ZM206 450.123H208C208 446.809 210.686 444.123 214 444.123V442.123V440.123C208.477 440.123 204 444.6 204 450.123H206Z",
    fill: "url(#paint0_linear_33_6)",
    mask: "url(#path-1-inside-1_33_6)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_33_6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1256 192C1256 196.418 1259.58 200 1264 200H1327.45C1331.87 200 1335.45 203.582 1335.45 208V273C1335.45 277.418 1331.87 281 1327.45 281H1262.45C1258.03 281 1254.45 277.418 1254.45 273V209C1254.45 204.582 1250.87 201 1246.45 201H1182C1177.58 201 1174 197.418 1174 193V127C1174 122.582 1177.58 119 1182 119H1248C1252.42 119 1256 122.582 1256 127V192Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1264 200V202H1327.45V200V198H1264V200ZM1335.45 208H1333.45V273H1335.45H1337.45V208H1335.45ZM1327.45 281V279H1262.45V281V283H1327.45V281ZM1254.45 273H1256.45V209H1254.45H1252.45V273H1254.45ZM1246.45 201V199H1182V201V203H1246.45V201ZM1174 193H1176V127H1174H1172V193H1174ZM1182 119V121H1248V119V117H1182V119ZM1256 127H1254V192H1256H1258V127H1256ZM1248 119V121C1251.31 121 1254 123.686 1254 127H1256H1258C1258 121.477 1253.52 117 1248 117V119ZM1174 127H1176C1176 123.686 1178.69 121 1182 121V119V117C1176.48 117 1172 121.477 1172 127H1174ZM1182 201V199C1178.69 199 1176 196.314 1176 193H1174H1172C1172 198.523 1176.48 203 1182 203V201ZM1254.45 209H1256.45C1256.45 203.477 1251.97 199 1246.45 199V201V203C1249.77 203 1252.45 205.686 1252.45 209H1254.45ZM1262.45 281V279C1259.14 279 1256.45 276.314 1256.45 273H1254.45H1252.45C1252.45 278.523 1256.93 283 1262.45 283V281ZM1335.45 273H1333.45C1333.45 276.314 1330.77 279 1327.45 279V281V283C1332.97 283 1337.45 278.523 1337.45 273H1335.45ZM1327.45 200V202C1330.77 202 1333.45 204.686 1333.45 208H1335.45H1337.45C1337.45 202.477 1332.97 198 1327.45 198V200ZM1264 200V198C1260.69 198 1258 195.314 1258 192H1256H1254C1254 197.523 1258.48 202 1264 202V200Z",
    fill: "url(#paint1_linear_33_6)",
    mask: "url(#path-3-inside-2_33_6)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_6",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.076 303.828C716.076 451.088 618.711 570.465 498.606 570.465C378.5 570.465 -371.906 53.9679 -371.906 -93.292C-371.906 -240.552 706.282 -37.8213 826.387 -37.8213C946.493 -37.8213 716.076 156.568 716.076 303.828Z",
    fill: "url(#paint2_linear_33_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.541 934.853C800.541 1082.11 703.176 1201.49 583.071 1201.49C462.965 1201.49 -206.126 1167.17 -206.126 1019.91C-206.126 872.645 -156.668 523.821 -36.562 523.821C83.5436 523.821 800.541 787.593 800.541 934.853Z",
    fill: "url(#paint3_radial_33_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.65 516.848C938.122 443.218 883.42 299.209 943.473 195.194C1003.53 91.1799 1826.03 -300.442 1953.56 -226.812C2081.09 -153.182 1366.43 679.19 1306.37 783.205C1246.32 887.219 1193.18 590.478 1065.65 516.848Z",
    fill: "url(#paint4_linear_33_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.29 764.614C307.61 815.672 516.886 799.913 339.128 1014.23C304.038 1041.55 254.913 1097.06 339.128 1100.59C444.396 1105 474.023 1159.21 595.68 1156.06C717.337 1152.91 818.823 1174.97 1007.93 1174.97C1197.03 1174.97 1115.09 1090.5 1215.94 992.169C1316.8 893.835 1261.33 930.395 1233.59 648.629C1205.86 366.864 1174.97 713.555 741.29 764.614Z",
    fill: "#D9D9D9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_6)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 603.23,
    x2: 1427.29,
    y2: 603.23,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 925.969,
    x2: 1427.29,
    y2: 925.969,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 280.492,
    x2: 1427.29,
    y2: 280.492,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 441.86,
    x2: 1427.29,
    y2: 441.86,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 764.598,
    x2: 1427.29,
    y2: 764.598,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 119.122,
    x2: 1427.29,
    y2: 119.122,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 522.545,
    x2: 1427.29,
    y2: 522.545,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 845.283,
    x2: 1427.29,
    y2: 845.283,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 199.807,
    x2: 1427.29,
    y2: 199.807,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 1006.65,
    x2: 1427.29,
    y2: 1006.65,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 361.175,
    x2: 1427.29,
    y2: 361.175,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 683.916,
    x2: 1427.29,
    y2: 683.916,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -84.2831,
    y1: 38.437,
    x2: 1427.29,
    y2: 38.437,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 608.473,
    y1: -70.6123,
    x2: 608.473,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.733,
    y1: -70.6125,
    x2: 285.733,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 931.209,
    y1: -70.6123,
    x2: 931.209,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1253.95,
    y1: -70.6123,
    x2: 1253.95,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.362,
    y1: -70.6123,
    x2: 124.362,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 769.839,
    y1: -70.6123,
    x2: 769.839,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.103,
    y1: -70.6123,
    x2: 447.103,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1092.58,
    y1: -70.6125,
    x2: 1092.58,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1415.32,
    y1: -70.6123,
    x2: 1415.32,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.6794,
    y1: -70.6123,
    x2: 43.6794,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 689.156,
    y1: -70.6125,
    x2: 689.156,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.416,
    y1: -70.6123,
    x2: 366.415,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1011.9,
    y1: -70.6123,
    x2: 1011.9,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1334.63,
    y1: -70.6123,
    x2: 1334.63,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.05,
    y1: -70.6123,
    x2: 205.05,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 850.526,
    y1: -70.6123,
    x2: 850.526,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.786,
    y1: -70.6123,
    x2: 527.786,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1173.26,
    y1: -70.6123,
    x2: 1173.26,
    y2: 1096.79,
    stroke: "#222020",
    strokeWidth: 1.2607
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-3_33_6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1017.23 438.8C1017.23 443.218 1013.65 446.8 1009.23 446.8H865.02C860.601 446.8 857.02 443.218 857.02 438.8V375.72C857.02 371.302 860.601 367.72 865.02 367.72H1009.23C1013.65 367.72 1017.23 371.302 1017.23 375.72V438.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1009.23 446.8V445.8H865.02V446.8V447.8H1009.23V446.8ZM857.02 438.8H858.02V375.72H857.02H856.02V438.8H857.02ZM865.02 367.72V368.72H1009.23V367.72V366.72H865.02V367.72ZM1017.23 375.72H1016.23V438.8H1017.23H1018.23V375.72H1017.23ZM1009.23 367.72V368.72C1013.1 368.72 1016.23 371.854 1016.23 375.72H1017.23H1018.23C1018.23 370.749 1014.2 366.72 1009.23 366.72V367.72ZM857.02 375.72H858.02C858.02 371.854 861.154 368.72 865.02 368.72V367.72V366.72C860.049 366.72 856.02 370.749 856.02 375.72H857.02ZM865.02 446.8V445.8C861.154 445.8 858.02 442.666 858.02 438.8H857.02H856.02C856.02 443.771 860.049 447.8 865.02 447.8V446.8ZM1009.23 446.8V447.8C1014.2 447.8 1018.23 443.771 1018.23 438.8H1017.23H1016.23C1016.23 442.666 1013.1 445.8 1009.23 445.8V446.8Z",
    fill: "url(#paint5_linear_33_6)",
    mask: "url(#path-40-inside-3_33_6)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_6",
    x1: 206,
    y1: 360.123,
    x2: 206,
    y2: 522.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427885,
    stopColor: "#3466F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#CF4EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899038,
    stopColor: "#F6275D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_6",
    x1: 1174,
    y1: 200,
    x2: 1335.45,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427885,
    stopColor: "#3466F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#CF4EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899038,
    stopColor: "#F6275D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_6",
    x1: 147.502,
    y1: -19.5411,
    x2: 601.983,
    y2: 222.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_33_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.831 941.112) rotate(-29.3932) scale(777.019 1335.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33_6",
    x1: 1629.99,
    y1: 186.132,
    x2: 1193.12,
    y2: 458.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_33_6",
    x1: 857.02,
    y1: 407.26,
    x2: 1017.23,
    y2: 407.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.427885,
    stopColor: "#3466F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#CF4EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899038,
    stopColor: "#F6275D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.6ab517c453b5c07ea4ef5def116df853.svg";
export { ForwardRef as ReactComponent };